import { Intl } from '../../../constants';

/**
 * 插件函数化字段颜色
 */
export const getStyleMap = () => {
    return {
        string: { cls: 'color-string', text: Intl.get('text') },
        number: { cls: 'color-number', text: Intl.get('widget.number') },
        datetime: { cls: 'color-datetime', text: Intl.get('timestamp') },
        location: { cls: 'color-location', text: Intl.get('widget.address') },
        url: { cls: 'color-url', text: 'URL' },
        phone: { cls: 'color-phone', text: Intl.get('phone') },
        user: { cls: 'color-user', text: Intl.get('member.name') },
        dept: { cls: 'color-dept', text: Intl.get('dept.name') },
        widget: { cls: 'color-widget', text: 'ID' }
    };
};
/**
 * 插件函数化字段-类型对照关系
 */
export const FIELD_TYPE_MAP: Record<string, any> = {
    text: 'string',
    textarea: 'string',
    combo: 'string',
    combocheck: 'string',
    radiogroup: 'string',
    checkboxgroup: 'string',
    sn: 'string',
    number: 'number',
    aggregation: 'number',
    aggregationtext: 'string',
    datetime: 'datetime',
    location: 'location',
    image: 'url',
    upload: 'url',
    signature: 'url',
    phone: 'phone',
    user: 'user',
    usergroup: 'user',
    dept: 'dept',
    deptgroup: 'dept',
    app_id: 'widget',
    widget: 'widget',
    entry_id: 'widget',
    address: 'location',
    url: 'url',
    data_id: 'widget'
};
